import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ items, collapsed, onToggleCollapse, mobileOpen, onCloseMobile }) {
  const sidebarClass = ['fr-sidebar', collapsed ? 'fr-sidebar--collapsed' : '', mobileOpen ? 'fr-sidebar--mobileOpen' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <aside className={sidebarClass} aria-label="Navegación">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'space-between', gap: 10 }}>
        {!collapsed ? <div style={{ fontWeight: 900 }}>Suite</div> : <span aria-hidden>🏢</span>}
        <button type="button" className="fr-iconButton" onClick={onToggleCollapse} aria-label={collapsed ? 'Expandir sidebar' : 'Colapsar sidebar'}>
          {collapsed ? '»' : '«'}
        </button>
      </div>

      <nav className="fr-nav">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            className={({ isActive }) => `fr-navItem ${isActive ? 'fr-navItem--active' : ''}`}
            onClick={() => onCloseMobile?.()}
          >
            <span className="fr-navItem__icon" aria-hidden>
              {it.icon}
            </span>
            {!collapsed ? <span className="fr-navItem__label">{it.label}</span> : null}
          </NavLink>
        ))}
      </nav>

      <div style={{ marginTop: 'auto', display: 'grid', gap: 8 }}>
        {!collapsed ? <div style={{ color: 'var(--text-muted)', fontSize: 12, lineHeight: 1.3 }}>Portal · Monitor · Designer</div> : null}
        <button type="button" className="fr-button" onClick={() => onCloseMobile?.()}>
          {collapsed ? 'Cerrar' : 'Cerrar menú'}
        </button>
      </div>
    </aside>
  );
}
